<template>
    <div id="connection-status-toolbar">
        <v-toolbar
          dense
          floating
        >
            <v-chip
              class="ma-2 static-chip"
              color="primary"
            >
                <v-icon left>
                    mdi-gauge
                </v-icon>
                <span id="framerate-tag">FPS: </span>{{ framerate }}
            </v-chip>
            <v-chip
              class="ma-2 static-chip"
              color="primary"
            >
                <v-icon left>
                    mdi-monitor-screenshot
                </v-icon>
                <span id="resolution-tag">Resolution: </span>{{ resolution }}
            </v-chip>
            <v-icon left>
                mdi-signal
            </v-icon>
            <span id="optimization-tag">Optimization: </span>
            <v-select
                class="optimization-select"
                v-model="$store.state.featureStatus.degradationPreference"
                :items="degradationPreferenceItems"
                menu-props="auto"
                @change="onDegradationPreferenceChange"
                hide-details
                single-line
                dense
                solo
                :disabled=!$store.state.featureStatus.isDegradationPreferenceEnabled
            ></v-select>

        </v-toolbar>
    </div>
</template>

<script>
  import {sendViewerMessage, webRtcStatsSubject} from "../webRtcViewer";

  export default {
    name: "ConnectionStatusToolbar",
    data: () => ({
      degradationPreferenceItems: ['Balanced', 'Resolution', 'Framerate'],
      framerate: '---',
      resolution: '---'
    }),
    created () {
        // subscribe to webrtc status subject
      this.subscription = webRtcStatsSubject.subscribe({
        next: (webRtcStats) => {
          // before connection establishes there is no video data
          if (webRtcStats.data.video.inbound.length > 0) {
            const videoData = webRtcStats.data.video.inbound[0];
            this.framerate = videoData.framesPerSecond;
            this.resolution = `${videoData.frameWidth}x${videoData.frameHeight}`
          }
        }
      })
    },
    beforeDestroy() {
      this.subscription.unsubscribe()
    },
    methods: {
      onDegradationPreferenceChange: function (selectedDegradationPreference) {
        sendViewerMessage(JSON.stringify({ degradationPreference: selectedDegradationPreference }))
      }
    }
  }
</script>

<style scoped>
header {
    z-index: 20;
}
#connection-status-toolbar {
    z-index: 20;
}
.optimization-select {
    margin-left: 10px;
}
@media screen and (min-width: 200px) and (max-width: 1180px) {
    .static-chip {
        flex: 1 0 auto;
    }
    #framerate-tag, #resolution-tag, #optimization-tag {
        display: none;
    }
}
</style>
